/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Результат решения «отправлять ли письмо подтверждения»: счётчики попыток и таймер следующей
 * @export
 * @interface EmailVerificationSendResult
 */
export interface EmailVerificationSendResult {
  /**
   * Отправлено ли письмо по этому запросу
   * @type {boolean}
   * @memberof EmailVerificationSendResult
   */
  sent: boolean
  /**
   * Использовано писем из лимита за окно
   * @type {number}
   * @memberof EmailVerificationSendResult
   */
  attemptsUsed: number
  /**
   * Максимально писем за окно
   * @type {number}
   * @memberof EmailVerificationSendResult
   */
  attemptsMax: number
  /**
   * Сек до следующей возможности запросить отправку
   * @type {number}
   * @memberof EmailVerificationSendResult
   */
  nextAttemptIn: number
}

/**
 * Check if a given object implements the EmailVerificationSendResult interface.
 */
export function instanceOfEmailVerificationSendResult(
  value: object
): value is EmailVerificationSendResult {
  if (!('sent' in value) || value['sent'] === undefined) return false
  if (!('attemptsUsed' in value) || value['attemptsUsed'] === undefined)
    return false
  if (!('attemptsMax' in value) || value['attemptsMax'] === undefined)
    return false
  if (!('nextAttemptIn' in value) || value['nextAttemptIn'] === undefined)
    return false
  return true
}

export function EmailVerificationSendResultFromJSON(
  json: any
): EmailVerificationSendResult {
  return EmailVerificationSendResultFromJSONTyped(json, false)
}

export function EmailVerificationSendResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EmailVerificationSendResult {
  if (json == null) {
    return json
  }
  return {
    sent: json['sent'],
    attemptsUsed: json['attemptsUsed'],
    attemptsMax: json['attemptsMax'],
    nextAttemptIn: json['nextAttemptIn'],
  }
}

export function EmailVerificationSendResultToJSON(
  value?: EmailVerificationSendResult | null
): any {
  if (value == null) {
    return value
  }
  return {
    sent: value['sent'],
    attemptsUsed: value['attemptsUsed'],
    attemptsMax: value['attemptsMax'],
    nextAttemptIn: value['nextAttemptIn'],
  }
}
